// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__3eFZQ","list":"PatternAutocomplete_list__3Hqwn"};